export const tableOption = {
  'border': true,
  'index': true,
  'stripe': true,
  'menuAlign': 'center',
  'indexLabel': '序号',
  'align': 'center',
  'editBtn': false,
  'delBtn': false,
  'addBtn': false,
  'refreshBtn': false,
  'columnBtn': false,
  'searchBtn': false,
  'emptyBtn': false,
  'dic': [],
  'column': [{
    label: '数据表名称',
    prop: 'tableName',
    align: 'center'
  }, {
    label: '数据表注释',
    prop: 'tableComment',
    align: 'center',
    sortable: true
  }, {
    label: '数据引擎',
    prop: 'engine',
    align: 'center',
    sortable: true
  }, {
    label: '创建时间',
    prop: 'createTime',
    align: 'center',
    hide: false
  }]
}

export const formOption = {
  emptyBtn: false,
  submitText: '生成',
  submitBtn: false,
  column: [
    {
      label: '表名称',
      prop: 'tableName',
      disabled: true
    }, {
      label: '包名',
      prop: 'packageName',
      placeholder: '可为空，加载系统默认配置'
    },
    {
      label: '作者',
      prop: 'author',
      placeholder: '可为空，加载系统默认配置'
    },
    {
      label: '模块',
      prop: 'moduleName',
      placeholder: '可为空，加载系统默认配置'
    },
    {
      label: '表前缀',
      prop: 'tablePrefix',
      placeholder: '可为空，加载系统默认配置'
    },
    {
      label: '注释',
      prop: 'comments',
      placeholder: '可为空，加载表备注'
    }
  ]
}
